import React from 'react';
import PropTypes from 'prop-types';
import { useEffectOnce } from 'react-use';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../HealthcareWorkflowConstants';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import { annualExpenseValidator } from '../HealthcareWorkflowValidator';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import InputDollar from '../../InputDollar/InputDollarView';
import AdvForm from '../../../CommonComponents/AdvForm';
import Tooltip from '../../../CommonComponents/Tooltip';
import { ButtonWithTooltip } from './AnnualExpenseStyles';

const StartAtRetirementView = ({
  workflowId,
  branch,
  clientId,
  estimateExpenses,
  updateEstimateExpenses,
  annualExpense,
  updateAnnualExpense,
  isGoingForward,
  isCanadian,
}) => {
  useEffectOnce(() => {
    if (isCanadian) {
      updateEstimateExpenses(workflowId, clientId)(false);
    }
  });

  return (
    <AdvWorkflowStep
      branch={branch}
      workflowId={workflowId}
      id="AnnualExpense"
      canSkip={isGoingForward && (estimateExpenses === true || annualExpense)}
    >
      <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.AnnualExpense`} />

      <h2>How much will your health care cost annually?</h2>

      <AdvForm>
        {isCanadian ? (
          <InputDollar
            maxLength="256"
            placeholder="$ AMOUNT"
            id="adv-amount"
            className="sm text-center"
            value={annualExpense}
            isUnder
            onChange={updateAnnualExpense(workflowId, clientId)}
          />
        ) : (
          <ul className="horizontal school-list">
            <li className="school-item">
              <div onClick={() => updateEstimateExpenses(workflowId, clientId)(true)}>
                <div
                  className={`school-item__button-radio-empty${
                    estimateExpenses === true ? ' selected' : ''
                  }`}
                />
                <ButtonWithTooltip>
                  <button type="button" className="school-item__button school-item__button--wide">
                    Automatically estimate healthcare costs{' '}
                  </button>
                  <Tooltip
                    tag="span"
                    className="fa fa-question-circle more-info"
                    tooltipclassname="text-left"
                    tooltipchildren={
                      <div>
                        <div>
                          <b>Cost Estimates</b>
                        </div>

                        <br />

                        <div>Prior to 65</div>
                        <ul>
                          <li>Private Insurance</li>
                          <li>Additional Out of Pocket Expenses</li>
                        </ul>

                        <div>65 and older</div>
                        <ul>
                          <li>Medicare Part B &amp; D</li>
                          <li>Medigap</li>
                          <li>Additional Out of Pocket Expenses</li>
                        </ul>
                      </div>
                    }
                    orientation="bottomleft"
                  />
                </ButtonWithTooltip>
              </div>
            </li>
            <li className="school-item">
              <div onClick={() => updateEstimateExpenses(workflowId, clientId)(false)}>
                <div
                  className={`school-item__button-radio-empty${
                    estimateExpenses === false ? ' selected' : ''
                  }`}
                />
                <button type="button" className="school-item__button school-item__button--wide">
                  Use my own estimate
                </button>
              </div>
            </li>
            <li
              className={`school-item school-item__select ${
                estimateExpenses !== false ? 'school-item--hidden' : ''
              }`}
            >
              <InputDollar
                maxLength="256"
                placeholder="$ AMOUNT"
                id="adv-amount"
                className="sm text-center"
                value={annualExpense}
                isUnder
                onChange={updateAnnualExpense(workflowId, clientId)}
              />
            </li>
          </ul>
        )}
      </AdvForm>

      <Navigation
        nextIterators={[]}
        dirtyGraphNodes={[]}
        validator={annualExpenseValidator(estimateExpenses, annualExpense)}
        validationId={`${BACKEND_KEY}.AnnualExpense`}
        workflowId={workflowId}
        backendKey={BACKEND_KEY}
        validatedOnClick={() =>
          workflowAnalyticsEvents(workflowId, 'healthcare_annual_expense_completed')
        }
      />
    </AdvWorkflowStep>
  );
};

StartAtRetirementView.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  isGoingForward: PropTypes.bool.isRequired,
  estimateExpenses: PropTypes.bool.isRequired,
  annualExpense: PropTypes.number.isRequired,
  updateEstimateExpenses: PropTypes.func.isRequired,
  updateAnnualExpense: PropTypes.func.isRequired,
  isCanadian: PropTypes.bool.isRequired,
};

export default StartAtRetirementView;
